import rebates from "src/store/dataService/routes/conditionalRebates";
import { API } from "../types";
import accessories from "./accessories";
import account from "./account";
import creditApp from "./creditApp";
import creditIQ from "./creditIQ";
import deal from "./deal";
import messages from "./messages";
import payments from "./payments";
import testDrive from "./testDrive";
import tradeIn from "./tradeIn";
import vehicles from "./vehicles";

export default {
    [API.Accessories]: accessories,
    [API.Account]: account,
    [API.Deal]: deal,
    [API.Payments]: payments,
    [API.TradeIn]: tradeIn,
    [API.Vehicles]: vehicles,
    [API.ConditionalRebates]: rebates,
    [API.TestDrive]: testDrive,
    [API.Messages]: messages,
    [API.CreditApp]: creditApp,
    [API.CreditIQ]: creditIQ,
};
